import Myaxios from  '../utils/myaxios'

export function getFyList(data) {
    return Myaxios({
        url: '/manager/order/importFinanceList',
        params: data
    })
}

export function importFinanceList(data) {
    return Myaxios({
        url: '/manager/order/importFinanceList',
        params: data
    })
}

export function getSumMoneyLs(data) {
    return Myaxios({
        url: '/manager/order/getSumMoneyLs',
        params: data
    })
}

export function getFinanceList(data) {
    return Myaxios({
        url: '/manager/order/getFinancialFlowList',
        params: data
    })
}